import { MaterialSymbolsIconProps } from 'src/components/MaterialSymbolsIcon/MaterialSymbolsIcon';
import { CustomUnifyIconProps } from './CustomUnifyIcon/CustomUnifyIcon';

/**
 * Standardized properties type for all icons.
 */
export type UnifyIconProps = MaterialSymbolsIconProps & CustomUnifyIconProps;

/**
 * A dummy component used to generate a Dart [UnifyIconProps] class,
 * which is used by `createCustomUnifyIcon` & `createMaterialSymbolsIcon`.
 *
 * This component will throw when rendered, and should never be exported or used directly.
 *
 * @private
 */
export const DummyUnifyIcon: React.FC<UnifyIconProps> = () => {
  throw 'This component should never be used, and is just for generating Dart bindings';
};

export default DummyUnifyIcon;
